export default __webpack_public_path__ + "static/media/9.bf60cb47.mp3";